// Animation map for product animations - matches LiveStorePreview exactly
import Fire from '../../lottie/Fire.json';
import Burger from '../../lottie/Burger.json';
import Bestsale from '../../lottie/Bestsale.json';
import BigSale from '../../lottie/BigSale.json';
import specialoffer from '../../lottie/specialoffer.json';
import limitedoffer from '../../lottie/limitedoffer.json';
import Pepperonfire from '../../lottie/Pepperonfire.json';
import setmenu from '../../lottie/setmenu.json';
import BurgerHamburger from '../../lottie/BurgerHamburgerFastFoodRestaurant.json';
import Ordercompleted from '../../lottie/Ordercompleted.json';
import Ordernow from '../../lottie/Ordernow.json';
import OrderNowanimation from '../../lottie/OrderNowanimation.json';
import Order from '../../lottie/Order.json';
import ordernow2 from '../../lottie/ordernow2.json';

const ANIMATION_MAP = {
  'BurgerHamburgerFastFoodRestaurant.json': BurgerHamburger,
  'Burger.json': Burger,
  'Ordercompleted.json': Ordercompleted,
  'specialoffer.json': specialoffer,
  'Ordernow.json': Ordernow,
  'OrderNowanimation.json': OrderNowanimation,
  'Order.json': Order,
  'setmenu.json': setmenu,
  'Fire.json': Fire,
  'Bestsale.json': Bestsale,
  'limitedoffer.json': limitedoffer,
  'BigSale.json': BigSale,
  'Pepperonfire.json': Pepperonfire,
  'ordernow2.json': ordernow2
};

export default ANIMATION_MAP;
